import { dataHooks } from '@wix/data-hooks'

export const wixStudioSplitDataHooks = dataHooks<{
  title: {}
  option: { key: string }
  secondaryOption: { key: string }
  back: {}
  disclaimer: {}
}>('wix-studio-split')
